/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Results_EmptyInputs */

const en_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No endpoints cleared the relevance bar. Try describing the data you need.`)
};

const zh_hans1_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有接口达到相关度门槛。试着描述你需要的数据。`)
};

const pt_br2_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum endpoint atingiu a relevância mínima. Tente descrever os dados de que você precisa.`)
};

const es_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún endpoint alcanzó el nivel de relevancia. Prueba describir los datos que necesitas.`)
};

const fr_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun endpoint n’a passé le seuil de pertinence. Essayez de décrire les données dont vous avez besoin.`)
};

const de_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Endpoint hat die Relevanzschwelle erreicht. Beschreibe die Daten, die du brauchst.`)
};

const ru_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни один эндпоинт не прошёл порог релевантности. Попробуйте описать, какие данные вам нужны.`)
};

const it_search_results_empty = /** @type {(inputs: Search_Results_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun endpoint ha superato la soglia di rilevanza. Prova a descrivere i dati di cui hai bisogno.`)
};

/**
* | output |
* | --- |
* | "No endpoints cleared the relevance bar. Try describing the data you need." |
*
* @param {Search_Results_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_results_empty = /** @type {((inputs?: Search_Results_EmptyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Results_EmptyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_results_empty(inputs)
	if (locale === "pt-BR") return pt_br2_search_results_empty(inputs)
	if (locale === "es") return es_search_results_empty(inputs)
	if (locale === "fr") return fr_search_results_empty(inputs)
	if (locale === "de") return de_search_results_empty(inputs)
	if (locale === "ru") return ru_search_results_empty(inputs)
	if (locale === "it") return it_search_results_empty(inputs)
	return en_search_results_empty(inputs)
});